import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from 'sonner';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import Homepage from './pages/Homepage';
import BenefitsPage from './pages/BenefitsPage';
import ForArtistsPage from './pages/ForArtistsPage';
import ArtistPage from './pages/ArtistPage';
import ArtistsPage from './pages/ArtistsPage';
import EventPage from './pages/EventPage';
import EventsPage from './pages/EventsPage';
import EventCheckIn from './pages/EventCheckIn';
import EventSelfCheckIn from './pages/EventSelfCheckIn';
import ContactPage from './pages/ContactPage';
import AboutPage from './pages/AboutPage';
import ReleasePage from './pages/ReleasePage';
import ReleasesPage from './pages/ReleasesPage';
import StorePage from './pages/StorePage';
import DemoSubmissionPage from './pages/DemoSubmissionPage';
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import CoverArtGenerator from './pages/admin/CoverArtGenerator';
import ArtistAuth from './pages/artist/ArtistAuth';
import ArtistRegister from './pages/artist/ArtistRegister';
import ArtistDashboard from './pages/artist/ArtistDashboard';
import ArtistLinksPage from './pages/ArtistLinksPage';
import PressKitPage from './pages/PressKitPage';
import PromoLandingPage from './pages/promo/PromoLandingPage';
import AMRLinksPage from './pages/AMRLinksPage';
import ResetPassword from './pages/ResetPassword';

// Track page views on route change for Google Analytics
function PageTracker() {
  const location = useLocation();
  useEffect(() => {
    if (window.gtag) {
      window.gtag('config', 'G-RC5G7M2PC2', {
        page_path: location.pathname + location.search,
      });
    }
  }, [location]);
  return null;
}

function App() {
  return (
    <div className="App">
      <Toaster position="top-right" theme="dark" />
      <BrowserRouter>
        <PageTracker />
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<><Navigation /><Homepage /><Footer /></>} />
          <Route path="/about" element={<><Navigation /><AboutPage /><Footer /></>} />
          <Route path="/for-artists" element={<><Navigation /><ForArtistsPage /><Footer /></>} />
          <Route path="/artist-support" element={<><Navigation /><BenefitsPage /><Footer /></>} />
          <Route path="/benefits" element={<><Navigation /><BenefitsPage /><Footer /></>} />
          <Route path="/artists" element={<><Navigation /><ArtistsPage /><Footer /></>} />
          <Route path="/artists/:slug" element={<><Navigation /><ArtistPage /><Footer /></>} />
          <Route path="/events" element={<><Navigation /><EventsPage /><Footer /></>} />
          <Route path="/events/:eventId" element={<><Navigation /><EventPage /><Footer /></>} />
          <Route path="/events/:eventSlug/check-in" element={<EventCheckIn />} />
          <Route path="/events/:eventSlug/register" element={<EventSelfCheckIn />} />
          <Route path="/releases" element={<><Navigation /><ReleasesPage /><Footer /></>} />
          <Route path="/releases/:releaseId" element={<><Navigation /><ReleasePage /><Footer /></>} />
          <Route path="/contact" element={<><Navigation /><ContactPage /><Footer /></>} />
          <Route path="/store" element={<><Navigation /><StorePage /><Footer /></>} />
          <Route path="/store/success" element={<><Navigation /><StorePage /><Footer /></>} />
          
          {/* Demo Submission (public) */}
          <Route path="/submit-demo" element={<><Navigation /><DemoSubmissionPage /><Footer /></>} />
          
          {/* Public Cover Art Generator (hidden route - not in menu) */}
          <Route path="/cover-art" element={<><Navigation /><div className="page-container"><CoverArtGenerator isPublic={true} /></div><Footer /></>} />
          
          {/* Artist Link Page (public, no nav/footer for clean linktree look) */}
          <Route path="/links/:slug" element={<ArtistLinksPage />} />
          
          {/* Public Press Kit (standalone, no nav/footer) */}
          <Route path="/presskit/:slug" element={<PressKitPage />} />
          
          {/* Public Promo Landing Page (standalone, no nav/footer) */}
          <Route path="/promo/:slug" element={<PromoLandingPage />} />
          
          {/* AMR Links Page (standalone, no nav/footer) */}
          <Route path="/amr-links" element={<AMRLinksPage />} />
          
          {/* Admin Routes */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/reset-password" element={<ResetPassword type="admin" />} />
          <Route path="/admin/*" element={<AdminDashboard />} />
          
          {/* Artist Portal Routes */}
          <Route path="/artist/login" element={<ArtistAuth />} />
          <Route path="/artist/reset-password" element={<ResetPassword type="artist" />} />
          <Route path="/artist/register/:token" element={<ArtistRegister />} />
          <Route path="/artist/dashboard" element={<ArtistDashboard />} />
          <Route path="/artist/*" element={<ArtistDashboard />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
